import {dynamicRoutes} from './routes'
import API from '@/api/index'
import store from "@store";

function getApi() {
  const pageApi = {}
  Object.entries(API).forEach(([key, val]) => {
    if (val?.permission) {
      let {page, name} = val.permission;
      page = `menu_${page}`
      const obj = {id: `${val.method}_/adm/v3/${val.url}`, label: name};
      page in pageApi ? pageApi[page].push(obj) : pageApi[page] = [obj];
    }
  })
  return pageApi
}

//根据权限获取路由
export function getPermissionRoutes(permissionList) {
  let routes = +store.state.isAdmin === 1 ? dynamicRoutes : generatePermissionRoutes(dynamicRoutes, permissionList);
  routes[0] && (routes[0].path = "/index");
  //父元素默认重定向第一个子元素
  setDefaultRedirect(routes);
  return routes;
}

function generatePermissionRoutes(routes, permissionList) {
  let list = [];
  routes.forEach(route => {
    if (hasPermission(route, permissionList)) {
      let newRoute = {...route};
      newRoute.children && (newRoute.children = generatePermissionRoutes(newRoute.children, permissionList));
      list.push(newRoute);
    }
  });
  return list;
}

//获取树形结构
export function getRoutesTree(permissionList) {
  const pageApi = getApi();
  return generateTree(dynamicRoutes, permissionList, pageApi);
}

function generateTree(routes, permissionList, pageApi) {
  let list = [];
  routes.forEach(route => {
    let permission = hasPermission(route, permissionList);
    if (permission) {
      let tree = {
        label: route?.meta?.title,
        icon: route?.meta?.icon,
      };
      if (route.children && route?.meta?.subMenu) {
        tree.children = generateTree(route.children, permissionList, pageApi)
      } else if (route.children) {
        let childRoute = route.children[0];
        tree.label = childRoute.meta?.title;
        tree.icon = childRoute.meta?.icon;
        tree.id = `menu_${childRoute.meta?.permission[0]}`;
        tree.permissionId = permission.id;
        initRouteApi(tree, permissionList, pageApi);
      } else {
        tree.id = `menu_${route?.meta?.permission[0]}`;
        tree.permissionId = permission.id;
        initRouteApi(tree, permissionList, pageApi);
      }
      list.push(tree);
    }
  });
  return list;
}

function initRouteApi(route, permissionList, pageApi) {
  const apiList = pageApi[route.id];
  if (apiList) {
    let children = apiList;
    if (permissionList) {
      children = apiList.filter(item => {
        const permission = permissionList.find(permission => item.id === `${permission.method.toLowerCase()}_${permission.resource}`);
        item.permissionId = permission?.id;
        return permission;
      })
    }
    route.children = children;
  }
}

//判断权限
function hasPermission(route, permissionList) {
  if (!permissionList) return true;
  let routePermission = route?.meta?.permission || [];
  return permissionList.find(permission => routePermission.includes(permission.resource || permission));
}

//父元素默认跳转第一个子元素
function setDefaultRedirect(routes) {
  routes.forEach(route => {
    if (route?.children?.length) {
      let children = route.children.find(item => !item.hidden);
      children && (route.redirect = children.path);
      setDefaultRedirect(route.children)
    }
  });
}

//路由探索
export function getRouteByTitle(title, routes, parentTitle = "") {
  let list = [];
  routes.forEach(route => {
    let routerTitle = route?.meta?.title || "";
    let allTitle = parentTitle ? `${parentTitle} - ${routerTitle}` : routerTitle;
    if (routerTitle.toLowerCase().indexOf(title.toLowerCase()) !== -1) {
      let reg = new RegExp(title, "ig");
      list.push({id: route.path, label: allTitle.replace(reg, `<span class="color-danger">${allTitle.match(reg)[0]}</span>`)});
    }
    route?.children && (list = list.concat(getRouteByTitle(title, route.children, allTitle)));
  });
  return list;
}

//判断接口权限
export function checkApi(api) {
  const {apis, isAdmin} = store.state;
  return +isAdmin === 1 || !!apis[api]
}
export function hasApi(list) {
  const {apis, isAdmin} = store.state;
  return +isAdmin === 1 || !!list.find(api => apis[api])
}

//判断页面权限
export function checkPage(page) {
  const {permissions, isAdmin} = store.state;
  return +isAdmin === 1 || !!permissions.find(permission => permission === page)
}


